import { useEffect, useRef } from 'react'

function useAdditionalProductImpressionRegistration(
  onAdditionalProductImpressionChange: (offer?: App.AnyOffer) => void,
  offer?: App.AnyOffer,
) {
  const onAdditionalProductImpressionChangeRef = useRef(onAdditionalProductImpressionChange)

  useEffect(() => {
    onAdditionalProductImpressionChangeRef.current = onAdditionalProductImpressionChange
  }, [onAdditionalProductImpressionChange])

  useEffect(() => {
    onAdditionalProductImpressionChange(offer)
  }, [onAdditionalProductImpressionChange, offer])

  useEffect(() => {
    return () => {
      onAdditionalProductImpressionChangeRef.current()
    }
  }, [])
}

export default useAdditionalProductImpressionRegistration
